define([
	"dojo/_base/declare",
	"csi/action/MoveUpDownController"
], function(declare,MoveUpDownController) {

	return declare(MoveUpDownController, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		preProcess: function() {
			// summary: move selected row up/down
			var	view = this.widget;

			this.inherited(arguments);

			if (this.targetNode) {
				// determine row to insert source rows before (if not bBefore) - because this is table, we can't
				// appendChild unless adding to very last row in table (no matter the hierarchy level)
				var	body = view.bodyNode;
				var	rowAfterSource = view.getRefNodeNext(this.refNode);
				var	rowAfterTarget = this.m_bUp ? this.targetNode : view.getRefNodeNext(this.targetNode);
				var	row = this.refNode;

				// update query results
				var	qr = view.getQueryResultByDomNode(row);
				var	qrNext = rowAfterTarget ? view.getQueryResultByDomNode(rowAfterTarget) : null;
				qr.moveInStore(qrNext);
				
				// update DOM
				while (row != rowAfterSource) {
					rowNext = row.nextSibling;
					body.removeChild(row);

					if (rowAfterTarget) {
						body.insertBefore(row, rowAfterTarget);
					} else {
						body.appendChild(row);
					}

					row = rowNext;
				}

				// ensure that next row up or down is in view
				var	rowNext;

				if (this.m_bUp) {
					rowNext = view.getRefNodeNext(this.refNode, true);
				} else {
					rowNext = view.getRefNodeNext(rowAfterTarget);
					rowNext = rowNext ? rowNext.previousSibling : body.lastChild;
				}

				view.scrollIntoView(rowNext || this.refNode);
				view.highlight(this.refNode, true, true);
			}
		}
	});
});